export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7369_82544)">
                <path
                    d="M24.8 4.5H7.2C6.53726 4.5 6 5.03726 6 5.7V27.3C6 27.9627 6.53726 28.5 7.2 28.5H24.8C25.4627 28.5 26 27.9627 26 27.3V5.7C26 5.03726 25.4627 4.5 24.8 4.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 10.5H26" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 7.5H12" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="22" cy="7.5" r="1" fill="black" />
                <circle cx="16" cy="19.5" r="6.4" stroke="black" strokeWidth="1.2" />
                <path
                    d="M10 19.5V19.5C11.6639 18.2899 13.8937 18.2038 15.646 19.2821L16 19.5L16.354 19.7179C18.1063 20.7962 20.3361 20.7101 22 19.5V19.5"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_7369_82544">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
